import { gqlFetchList } from 'app/lib/graphqlClient'

/**
 * Creates a ComboAsync-compatible fetcher backed by GraphQL.
 * Replaces REST `queryURL="/api/{entity}"` usage.
 */
export function createGqlFetcher(entityName: string, options?: { limit?: number }) {
  return async (params: { query?: string; [key: string]: any }) => {
    const searchTerms: string[] = []
    if (params.query) searchTerms.push(params.query)
    // Forward common filter params as search terms
    for (const [key, value] of Object.entries(params)) {
      if (key === 'query' || !value) continue
      searchTerms.push(`${key}:${value}`)
    }
    const search = searchTerms.length ? searchTerms.join(' ') : undefined
    return gqlFetchList(entityName, {
      search,
      pagination: { limit: options?.limit ?? 100 },
    })
  }
}
